module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-result-found-ec1e32271bd3082b56a19eee4c631148.svg";